import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Shell } from "@/components/Shell";

export default function Privacy() {
  const [policy, setPolicy] = useState(null);
  useEffect(() => {
    api.get("/retention/policy").then(({ data }) => setPolicy(data));
  }, []);

  return (
    <Shell>
      <div className="rise" data-testid="privacy-page">
        <p className="overline">PDPA</p>
        <h1 className="font-display text-4xl font-black uppercase tracking-tight leading-none mt-2">
          Privacy &amp; data retention
        </h1>
        <div className="card p-6 mt-8 space-y-4 text-sm text-slate-300 leading-relaxed">
          <p>{policy?.summary || "Loading policy…"}</p>
          <ul className="list-disc pl-5 space-y-2 text-slate-400">
            <li>We collect name, email, optional phone, company and job title — only for event operations.</li>
            <li>QR passes are random tokens; they contain no personal data and cannot be reverse-engineered.</li>
            <li>
              Check-in records store the time and station only, and are retained for{" "}
              <span className="font-mono2 text-slate-200">{policy?.retention_days ?? "—"} days</span> after the event.
            </li>
            <li>Survey responses are linked to your registration so we can avoid duplicates, and are reported in aggregate.</li>
            <li>Organisers can anonymise all personal data for an event at any time from the command center.</li>
            <li>You may request access, correction or deletion by replying to any pass email.</li>
          </ul>
        </div>
      </div>
    </Shell>
  );
}
